import React from "react";
import ReactModal from "react-modal";
import { axiosget, axiospost, axiosput } from "../../helpers/httprequest";
import swal from "../../helpers/swal";
import { Field, Form, Formik } from "formik";
import { ms_applicant_result } from "@v2/validators";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";

const BtnOLevelResult = ({ modules }) => {
  const [showmodal, setshowmodal] = React.useState(false);
  const queryClient = useQueryClient(); // Access the Query Client
  const { data, isLoading, error } = useQuery({
    queryKey: ["oLevelCompleteResult"], // Same queryKey as Component 1
    queryFn: async () => {
      const req = await axiosget("ms_applicant_sitting");
      return req?.data;
    }, // Function to fetch data if not in cache
  });

  const _save = async (values) => {
    try {
      let req;
      if (modules === undefined) {
        req = await axiospost("ms_applicant_result", values);
      } else {
        req = await axiosput(`ms_applicant_result/${modules?._id}`, values);
      }
      if (req.status !== 200) {
        throw new Error("Sorry, system could not finish processing your request");
      }
      const { data: result } = req;
      if (result && result.type === "success") {
        const { message, type } = result;
        swal(type, message);
        queryClient.invalidateQueries({ queryKey: ["oLevelResult"] });
      } else {
        throw new Error(result.message);
      }
    } catch ({ message }) {
      swal("warning", message);
    }
  };

  const _show = () => {
    setshowmodal(true);
  };

  return (
    <div>
      <ReactModal isOpen={showmodal} onRequestClose={() => setshowmodal(false)} className="ReactModal">
        <div className="modal-dialog " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-center">Student O-Level Result</h5>
              <span className="text-danger pointer" onClick={() => setshowmodal(false)}>
                x
              </span>
            </div>
            <div className="modal-body">
              {isLoading && <Loader />}
              {error && <ErrorResponse type={`danger`} message={`Local server error: ${error}`} />}
              {data?.type !== undefined && <ErrorResponse type={`danger`} message={`${data?.message}`} />}
              {data?.type === undefined && (
                <Formik
                  initialValues={{
                    examination: modules ? modules?.examination?._id : "",
                    scored: modules ? modules?.scored : "",
                    subject: modules ? modules?.subject : "",
                  }}
                  validationSchema={ms_applicant_result.createSitting}
                  initialTouched={{ zip: true }}
                  onSubmit={_save}
                >
                  {({ isSubmitting, touched, errors }) => (
                    <Form>
                      <div className="row">
                        <div className="col-md-12 ">
                          <div className="form-group form-floating">
                            <Field
                              as="select"
                              name="examination"
                              errors={errors?.examination}
                              className={`form-control form-control-lg ${errors?.examination && "is-invalid"}`}
                            >
                              <option value="">Select Option</option>
                              {data &&
                                data?.map((r, i) => (
                                  <option key={`OResult_opt_P${i}`} value={r?._id}>
                                    {r?.examinationtype} {r?.examinationnumber}
                                  </option>
                                ))}
                            </Field>
                            <label htmlFor="firstname">Select Examination Sitting</label>
                            {errors?.examination && touched?.examination ? (
                              <div className="text-danger mt-1 p-1 text-small">{errors?.examination}</div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group form-floating">
                            <Field
                              as="select"
                              name="subject"
                              errors={errors?.subject}
                              className={`form-control form-control-lg ${errors?.subject && "is-invalid"}`}
                            >
                              <option value="">Select Option</option>
                              <option value="Additional General Science">Additional General Science</option>
                              <option value="Additional Mathematics">Additional Mathematics</option>
                              <option value="Agricultural Science">Agricultural Science</option>
                              <option value="Animal Husbandry">Animal Husbandry</option>
                              <option value="Applied Mathematics">Applied Mathematics</option>
                              <option value="Arabic Language">Arabic Language</option>
                              <option value="Biology">Biology</option>
                              <option value="Botany">Botany</option>
                              <option value="Chemistry">Chemistry</option>
                              <option value="CRS/IRS">CRS/IRS</option>
                              <option value="Commerce">Commerce</option>
                              <option value="Civic Education">Civic Education</option>
                              <option value="Computer Studies">Computer Studies</option>
                              <option value="Data Processing">Data Processing</option>
                              <option value="English Language">English Language</option>
                              <option value="Economics">Economics</option>
                              <option value="Food Economics">Food Economics</option>
                              <option value="Food Management">Food Management</option>
                              <option value="Food Science">Food Science</option>
                              <option value="Food and Nutrition">Food and Nutrition</option>
                              <option value="Further Mathematics">Further Mathematics</option>
                              <option value="Fine and Applied Arts">Fine and Applied Arts</option>
                              <option value="Financial Accounting">Financial Accounting</option>
                              <option value="French">French</option>
                              <option value="General Biology">General Biology</option>
                              <option value="General Education">General Education</option>
                              <option value="General Science">General Science</option>
                              <option value="Government">Government</option>
                              <option value="Geography">Geography</option>
                              <option value="Geology">Geology</option>
                              <option value="Geography">Geography</option>
                              <option value="Hausa Language">Hausa Language</option>
                              <option value="Health Science">Health Science</option>
                              <option value="Human Biology">Human Biology</option>
                              <option value="Hygiene">Hygiene</option>
                              <option value="History">History</option>
                              <option value="Integrated Science">Integrated Science</option>
                              <option value="Igbo">Igbo</option>
                              <option value="Islamic History">Islamic History</option>
                              <option value="Literature in English">Literature in English</option>
                              <option value="Mathematics">Mathematics</option>
                              <option value="Music">Music</option>
                              <option value="Marketing">Marketing</option>
                              <option value="Other Nigerian Languages">Other Nigerian Languages</option>
                              <option value="Physics">Physics</option>
                              <option value="Pure and Applied Mathematics">Pure and Applied Mathematics</option>
                              <option value="Principles of Accounts">Principles of Accounts</option>
                              <option value="Qua'anic Studies">Qua'anic Studies</option>
                              <option value="Rural Biology">Rural Biology</option>
                              <option value="Rural Science">Rural Science</option>
                              <option value="Social Studies">Social Studies</option>
                              <option value="Statistics">Statistics</option>
                              <option value="Tahfeezul Qur'an">Tahfeezul Qur'an</option>
                              <option value="Teaching Practice">Teaching Practice</option>
                              <option value="Ulumul Qur'an">Ulumul Qur'an</option>
                              <option value="Zoology">Zoology</option>
                            </Field>
                            <label htmlFor="firstname">Select Examination subject</label>
                            {errors?.subject && touched?.subject ? <div className="text-danger mt-1 p-1 text-small">{errors?.subject}</div> : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group form-floating">
                            <Field
                              as="select"
                              name="scored"
                              errors={errors?.scored}
                              className={`form-control form-control-lg ${errors?.scored && "is-invalid"}`}
                            >
                              <option value="">Select Result Option</option>
                              <option value="A1">A1</option>
                              <option value="B2">B2</option>
                              <option value="B3">B3</option>
                              <option value="C4">C4</option>
                              <option value="C5">C5</option>
                              <option value="C6">C6</option>
                              <option value="D7">D7</option>
                              <option value="E8">E8</option>
                              <option value="F9">F9</option>
                            </Field>
                            <label htmlFor="firstname">Select Result Option</label>
                            {errors?.scored && touched?.scored ? <div className="text-danger mt-1 p-1 text-small">{errors?.scored}</div> : null}
                          </div>
                        </div>

                        <div className="col-md-12 text-right">
                          <button disabled={isSubmitting} type="submit" className="btn btn-lg btn-primary btn-block">
                            {isSubmitting ? `Please wait...` : `Save`}
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              )}
            </div>
          </div>
        </div>
      </ReactModal>
      <div>
        {!modules && (
          <div
            style={{
              position: "fixed",
              right: "50px",
              bottom: "50px",
            }}
          >
            <button className="btn btn-icon btn-primary btn-rounded" onClick={_show}>
              <i className="ti-plus"></i>
            </button>
          </div>
        )}
      </div>
      <div>
        {modules && (
          <button className="btn btn-icon btn-primary btn-rounded" onClick={_show}>
            <i className="ti-pencil"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default BtnOLevelResult;
